import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import { SideBarIndex } from '../../pages/map/side-bar/side-bar.model';

@Component({
  selector: 'app-icon-view-center-left',
  templateUrl: './icon-view-center-left.component.html',
  styleUrls: ['./icon-view-center-left.component.scss']
})
export class IconViewCenterLeftComponent implements OnInit {
  @Input() tabIndex: SideBarIndex;
  TabIndex = SideBarIndex;
  @Output() indexIconBar = new EventEmitter<number>();

  constructor() { }

  ngOnInit() {

  }

  search() {
    this.indexIconBar.emit(SideBarIndex.Search);
  }

  displayLayer() {
    this.indexIconBar.emit(SideBarIndex.LayerList);
  }

  legend() {
    this.indexIconBar.emit(SideBarIndex.Legend);
  }

  printer() {
    this.indexIconBar.emit(SideBarIndex.Printer);
  }

  close() {
    this.indexIconBar.emit(SideBarIndex.None);
  }
}
